var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gc-card-navigation-skeleton"},[_c('div',{staticClass:"gc-card-navigation"},[_c('div',{staticClass:"gc-header-simple"},[_c('AnimatedPlaceholder',{attrs:{"width":"200px","height":"18px"}}),_c('AnimatedPlaceholder',{attrs:{"width":"12px","height":"24px"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }